import { ReactElement } from 'react';

import { SkeletonLoader } from '@twilio-paste/core/skeleton-loader';
import { Stack } from '@twilio-paste/core/stack';
import { dataTestIds } from '@twiliointernal/e2-commons-shared-definitions';

const ArticleLoaders = (): ReactElement => {
  return (
    <Stack
      data-testid={dataTestIds.articleLoader}
      orientation="vertical"
      spacing="space80"
    >
      <SkeletonLoader height="44px" width="100%" />

      <Stack orientation="vertical" spacing="space40">
        <SkeletonLoader height="32px" width="60%" />
        <SkeletonLoader width="100%" />
        <SkeletonLoader width="100%" />
        <SkeletonLoader width="100%" />
        <SkeletonLoader width="100%" />
      </Stack>

      <Stack orientation="vertical" spacing="space40">
        <SkeletonLoader height="32px" width="30%" />
        <SkeletonLoader height="128px" width="100%" />
        <SkeletonLoader width="40%" />
        <SkeletonLoader width="100%" />
      </Stack>

      <SkeletonLoader height="64px" width="100%" />
    </Stack>
  );
};

export default ArticleLoaders;
